import { apiRootEndpoint } from '../config';
import { useFlexAssessmentContext } from '../context/context';
import { AccessCodeApiResponse } from '../types/access-code-api-response';
import { AccessCodeConfig } from '../types/access-code-config';
import { FlexAssessmentContextAction } from '../types/flex-assessment-context-action';
import { OrgConfigApiResponse } from '../types/org-config-api-response';
import { ProgramType } from '../types/types';
import { AccessCodeError, PartnerWebConfigError } from '../utils/errors';
import { fetcher } from '../utils/fetcher';

export default function useAccessCodeApi(): Record<string, Function> {
  const { dispatch } = useFlexAssessmentContext();

  const getAccessCodeConfig = async (code: string): Promise<void | Error> => {
    try {
      if (!code) {
        throw Error('Empty AccessCode param');
      }
      const res = await fetcher<AccessCodeApiResponse>(
        `${apiRootEndpoint}/v1/access-codes/${code}`
      );
      dispatch({
        type: FlexAssessmentContextAction.setAccessCodeConfig,
        payload: res.data,
      });
    } catch (error) {
      return new AccessCodeError(code, error);
    }
  };

  const getOrgConfig = async (_alias: string): Promise<void | Error> => {
    if (!_alias) {
      return;
    }

    const aliasMap: Record<string, string> = {
      ngmbarrick: 'ngmbarrickflex',
      dekalb: 'dekalbflex',
    };

    const alias = aliasMap[_alias?.toLowerCase()] ?? _alias;

    try {
      const res = await fetcher<OrgConfigApiResponse>(
        `${apiRootEndpoint}/v1/organizations/${alias}/web-template-config`
      );
      dispatch({
        type: FlexAssessmentContextAction.setOrgConfig,
        payload: res.data.webTemplate,
      });
    } catch (err) {
      new PartnerWebConfigError(alias);
    }
  };

  const checkIsAccessCodeAllowed = (
    accessCodeConfig: AccessCodeConfig
  ): boolean => {
    if (
      !accessCodeConfig ||
      !accessCodeConfig.accessCode ||
      accessCodeConfig.program !== ProgramType.flex ||
      accessCodeConfig.status !== 'available'
    ) {
      return false;
    }
    return true;
  };

  const checkIsAccessCodeIsFull = (
    accessCodeConfig: AccessCodeConfig
  ): boolean => {
    return accessCodeConfig.status === 'full';
  };

  return {
    getAccessCodeConfig,
    getOrgConfig,
    checkIsAccessCodeAllowed,
    checkIsAccessCodeIsFull,
  };
}
